import * as faceapi from '@vladmandic/face-api';
import axios from 'axios';

let modelsLoaded = false;

/**
 * Ensure face-api models are loaded (idempotent).
 */
export async function ensureModelsLoaded() {
  if (modelsLoaded) return true;
  try {
    await Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
      faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
      faceapi.nets.faceRecognitionNet.loadFromUri('/models'),
    ]);
    modelsLoaded = true;
    return true;
  } catch (e) {
    console.warn('Face models failed to load:', e);
    return false;
  }
}

/**
 * Extract the 128-dim face descriptor from an image element or blob URL.
 * Returns Float32Array or null if no face detected.
 */
export async function extractDescriptor(imageSource) {
  await ensureModelsLoaded();
  let img;
  if (typeof imageSource === 'string') {
    // data URL or blob URL
    img = await faceapi.fetchImage(imageSource);
  } else {
    img = imageSource; // HTMLImageElement or HTMLVideoElement
  }
  const detection = await faceapi
    .detectSingleFace(img, new faceapi.TinyFaceDetectorOptions({ scoreThreshold: 0.4 }))
    .withFaceLandmarks()
    .withFaceDescriptor();
  return detection ? detection.descriptor : null;
}

/**
 * Register a patient's face descriptor in the DB.
 * Call this after capturing their photo during registration.
 *
 * @param {string} API_BASE
 * @param {string} patientId
 * @param {string} photoDataUrl — base64 data URL of the captured photo
 */
export async function registerFace(API_BASE, patientId, photoDataUrl) {
  try {
    const descriptor = await extractDescriptor(photoDataUrl);
    if (!descriptor) {
      console.warn('No face detected in photo — skipping face registration');
      return false;
    }
    await axios.post(`${API_BASE}/face/register`, {
      patientId,
      descriptor: Array.from(descriptor),
    });
    console.log('Face registered for patient', patientId);
    return true;
  } catch (e) {
    console.warn('Face registration failed:', e);
    return false;
  }
}
